export default function CustomFilterDropdownListItem(props: {
  label: string;
  chipLabel: string;
}) {
  return (
    <div className="d-flex flex-row align-items-center p-2">
      <div className="flex-grow-1 text">{props.label}</div>
      <small className="badge small rounded-pill ms-auto">
        {props.chipLabel}
      </small>
    </div>
  );
}
